module.exports = __webpack_public_path__ + "assets/images/img/Level_tennis.3681deb3cade31391a098b9a8521c9f3.png";